import { color, media, radius, spacing, typography } from '@gyym/ui'
import styled from 'styled-components'

import { FacilityLpBanner } from '@/components/UI/FacilityLpBanner'

export const Container = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.colors.gray['01']};
  margin-bottom: ${spacing(6)};

  ${media.tablet} {
    margin-bottom: ${spacing(8)};
  }
`

export const SearchLabel = styled.span`
  ${typography('caption1')};
  margin-top: ${spacing(2)};
  color: ${color('blue.01')};
  white-space: nowrap;
`

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  height: 62px;
`

export const SearchCardButton = styled.button`
  cursor: pointer;
  text-decoration: none;
  background-color: ${color('white')};
  border: 1px solid ${color('blue.01')};
  border-radius: ${radius('xs')};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100px;
  width: 100%;
  transition: box-shadow 0.2s ease;
  box-shadow: 4px 3px 12px 0 rgba(0, 0, 0, 0.1);

  &:hover {
    box-shadow: 4px 3px 15px 0 rgba(0, 0, 0, 0.2);
  }
`

export const SearchButtons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${spacing(3)};
  width: 100%;
  max-width: 292px;
  margin: 0 auto;

  ${media.pc} {
    grid-template-columns: repeat(4, 1fr);
    max-width: 436px;
  }
`

export const AreaBlock = styled.div`
  width: 100%;
  max-width: 354px;
`

export const AreaButtons = styled.div`
  margin-top: ${spacing(6)};
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${spacing(3)};
`

export const AreaButtonLabel = styled.span`
  ${typography('subhead1')};
  color: ${color('white')};
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.45);
`

export const AreaButton = styled.span`
  display: block;
  position: relative;
  padding: 0;
  word-break: keep-all;

  ${AreaButtonLabel} {
    position: absolute;
    z-index: 10;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  & > img {
    width: 100%;
  }
`

export const SearchWrapper = styled.div`
  display: flex;
  width: 100%;
  margin: 0 auto;
  max-width: calc(1024px + ${spacing(4)});
`

export const StyledFacilityLpBanner = styled(FacilityLpBanner)`
  margin: ${spacing(15)} auto 0;
`
